import { useEffect, useRef } from "react";
import NavLinks from "../components/NavLinks";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import About from "../components/About";

export default function Footer() {
  const footeRef = useRef(null);
  const { isAuth } = useAuth();
  useEffect(() => {
    const fooHeith = footeRef.current;
    document.documentElement.style.setProperty("--footer-height", `${fooHeith.offsetHeight}px`);
  }, []);
  return (
    <footer className="footer full-w relative" ref={footeRef}>
      <NavLinks position={"footer"} />

      {!isAuth && <About />}
    </footer>
  );
}
